import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const vatReportSchema = z.object({
  vatReport: z.object({
    name: z.string().optional().nullable(),
    identificationNumber: z.string().optional().nullable(),
    excludeProcedure40: z.boolean().optional().nullable(),
    authorizedET14000: z.boolean().optional().nullable(),
    address: z.object({
      street: z.string().optional().nullable(),
      postcode: z.string().optional().nullable(),
      city: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
      region: z.string().optional().nullable(),
    }),
    contactPerson: z.object({
      email: z.string().email({ message: 'Invalid email address' }),
    }),
  }),
});
export type VatReportFormValues = z.infer<typeof vatReportSchema>;

export const useVatReportFormInitializer = ({ declarant }) => {
  const buildFormValues = (declarant) => {
    const { vatReport } = declarant || {};

    return {
      vatReport: {
        name: vatReport?.name || '',
        identificationNumber: vatReport?.identificationNumber || '',
        excludeProcedure40: vatReport?.excludeProcedure40 || false,
        authorizedET14000: vatReport?.authorizedET14000 || false,
        address: {
          street: vatReport?.address?.street || '',
          postcode: vatReport?.address?.postcode || '',
          city: vatReport?.address?.city || '',
          country: vatReport?.address?.country || '',
          region: vatReport?.address?.country || '',
        },
        contactPerson: {
          email: vatReport?.contactPerson?.email || '',
        },
      },
    };
  };

  const form = useForm<VatReportFormValues>({
    initialValues: buildFormValues(declarant),
    validate: zodResolver(vatReportSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
